export default "__VITE_ASSET__CzlCtSVN__"